// Backend slot wire format: itemId === -1 means empty.
export interface InventorySlot {
    itemId: number;
    count: number;
    damage: number;
    snbt?: string | null;
}

export interface WindowSnapshot {
    id: number;
    type: string;
    title: string;
    slotCount: number;
    slots: InventorySlot[];
}

export interface InventorySnapshot {
    activeHotbar: number;
    slots: InventorySlot[];
    cursor: InventorySlot;
    window: WindowSnapshot | null;
}

export type InventoryArea = 'player' | 'container';

export interface SlotRef {
    area: InventoryArea;
    slot: number;
}

export const isInventorySlotEmpty = (s: InventorySlot | undefined) => !s || s.itemId < 0 || s.count === 0;
